import React from 'react'
import { StyledLink } from './styles.js'

const ButtonPrimary = ({ url, label }) => (

    <StyledLink to={url}>{label}</StyledLink>

)

export default ButtonPrimary